module.exports = __webpack_public_path__ + "static/media/Note-Click-Enter-Textures-Click_in_00021.5171d2ed.png";